














































































































import Vue from 'vue'

import { BrandModel } from '@/common/types/brands'
import { ProductCategory } from '@/model/productCategory'
import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES } from '@/common/constants'
import CategoriesList from '@/common/components/CategoriesList.vue'
import BaseImage from '@/common/components/BaseImage.vue'

enum MENU_ITEMS {
  BRANDS,
  CATEGORIES
}

export default Vue.extend({
  components: {
    CategoriesList,
    BaseImage
  },
  props: {
    categories: {
      type: Array as () => ProductCategory[],
      required: true
    },
    brands: {
      type: Array as () => BrandModel[],
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    activeId: number
  } {
    return {
      activeId: MENU_ITEMS.CATEGORIES
    }
  },
  computed: {
    MENU_ITEMS() {
      return MENU_ITEMS
    },
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.BRAND_LOGO
    }
  },
  created() {
    if (this.brands.length === 0) {
      this.$emit('fetchMenuData')
    }
  },
  mounted() {
    const offsetLeft = this.$el.getBoundingClientRect().x as number
    (this.$el as HTMLElement).style.left = `-${offsetLeft}px`
  },
  methods: {
    getBrandUrl(brandName: string) {
      return `/brands/${brandName}`
    }
  }
})
